import Button from '@/components/Button';
import Modal from '@/components/Modal';
import { LAZAI_TELEGRAM, OFFICIAL_X } from '@/constant';
import { TYPE } from '@/theme';

import React from 'react';
import styled from 'styled-components';

interface HowToGetBoxModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const Wrapper = styled.div`
    width: 320px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 0 0 0;
    overflow: hidden;

    .content {
        width: 100%;
        text-align: left;
        p {
            margin: 16px 0;
        }

        a {
            color: rgba(53, 99, 243, 1);
        }
    }

    .instruction-text {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
        margin-bottom: 16px;
    }

    .footer {
        width: 100%;
        margin-top: 20px;

        .button {
            width: 100%;
            background-color: rgba(53, 99, 243, 1);
        }
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    `};
`;

export const HowToGetBoxModal: React.FC<HowToGetBoxModalProps> = ({
    isOpen,
    onClose,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="How to get a box?">
            <Wrapper>
                <div className="content">
                    <p>
                        <TYPE.main fontSize={14}>
                            If you haven't got the blind box yet, earn points to
                            get a redeem code.
                        </TYPE.main>
                    </p>
                    <p>
                        <TYPE.main fontSize={14}>
                            Users who reach the points milestone may also share
                            their redeem codes.
                        </TYPE.main>
                    </p>

                    <p>
                        <TYPE.main fontSize={14}>
                            Follow us on{' '}
                            <a href={OFFICIAL_X} target="_blank">
                                X
                            </a>{' '}
                            or join our{' '}
                            <a href={LAZAI_TELEGRAM} target="_blank">
                                Telegram{' '}
                            </a>{' '}
                            group to look for a code.
                        </TYPE.main>
                    </p>
                </div>

                <div className="footer">
                    <Button className="button" onClick={onClose} size="middle">
                        Ok
                    </Button>
                </div>
            </Wrapper>
        </Modal>
    );
};
